import { watch } from "vue";
import { useCurrentOrganization } from "@/composables/useCurrentOrganization";
import { setMixpanelOrganization } from "@/shared/utils/analytics";

/**
 * Keeps the Mixpanel `orgId` / `orgName` super properties on the org the admin
 * is working in right now, including a network admin or TFA employee
 * impersonating one.
 */
export function useMixpanelOrganization() {
  const { currentOrganization } = useCurrentOrganization();

  watch(currentOrganization, (org) => setMixpanelOrganization(org), {
    immediate: true,
  });
}
